export enum BRANCH_SCREEN_LIST {

}

export enum BRANCH_REQUEST_ID_LIST {
  GET_BRANCH = 'GET_BRANCH',
  DELETE_BRANCH = 'DELETE_BRANCH',
  DELETE_MART_BRANCH = 'DELETE_MART_BRANCH',
  ADD_BRANCH = 'ADD_BRANCH',
  ADD_MART_BRANCH = 'ADD_MART_BRANCH',
  EDIT_BRANCH = 'EDIT_BRANCH',
  GET_VAT_ADDRESS = 'GET_VAT_ADDRESS',
  MAPPING_BRANCH_VAT = 'MAPPING_BRANCH_VAT'
}